import { http } from "@/http/axios.js";

// 变更收货地址
export function updateOrderAddressAPI(data) {
  return http({
    url: "/admin/order/address/edit",
    method: "post",
    data,
  });
}
// 审核同意
export function handleReviewPassAPI(data) {
  return http({
    url: "/admin/review/order/pass",
    method: "post",
    data,
  });
}
// 审核取消
export function handleReviewCancelAPI(data) {
  return http({
    url: "/admin/review/order/cancel",
    method: "post",
    data,
  });
}
// 审核拒绝
export function handleReviewRefuseAPI(data) {
  return http({
    url: "/admin/review/order/refuse",
    method: "post",
    data,
  });
}
// 备注列表
export function getRemarkListAPI(params) {
  return http({
    url: "/admin/order/trace/page",
    method: "get",
    params,
  });
}
// 添加备注
export function handleAddRemarkAPI(data) {
  return http({
    url: "/admin/order/trace/add",
    method: "post",
    data,
  });
}
// 用户评分
export function handleMemberGradeAPI(data) {
  return http({
    url: "/admin/member/grade",
    method: "post",
    data,
  });
}
// 紧急联系人列表
export function getRelationListAPI(orderNo) {
  return http({
    url: "/admin/order/member/relation/list",
    method: "get",
    params: { orderNo },
  });
}
// 添加紧急联系人
export function addRelationAPI(data) {
  return http({
    url: "/admin/order/member/relation/add",
    method: "post",
    data,
  });
}
// 编辑紧急联系人
export function editRelationAPI(data) {
  return http({
    url: "/admin/order/member/relation/edit",
    method: "post",
    data,
  });
}
// 校验紧急联系人
export function riskRelationAPI(data) {
  return http({
    url: "/admin/order/member/relation/risk/alert",
    method: "post",
    data,
  });
}
// 紧急联系人详情
export function getRelationDetailAPI(id) {
  return http({
    url: "/admin/order/member/relation/detail",
    method: "get",
    params: { id },
  });
}
// 删除紧急联系人
export function delRelationAPI(id) {
  return http({
    url: "/admin/order/member/relation/delete",
    method: "post",
    data: { id },
  });
}
// 修改零售价
export function updatePriceAPI(data) {
  return http({
    url: "/admin/order/salePrice/edit",
    method: "post",
    data,
  });
}
// 保存订单用户资料
export function saveOrderMemberProfileAPI(data) {
  return http({
    url: "/admin/order/member/profile/save",
    method: "post",
    data,
  });
}
// 修改订单最终评级
export function updateFinalHitGradeAPI(data) {
  return http({
    url: "/admin/order/score/grade/edit",
    method: "post",
    data,
  });
}
// 修改门店方案列表
export function getStoreComboList(params) {
  return http({
    url: "/admin/order/store/combo/list",
    method: "get",
    params,
  });
}

// 修改门店方案
export function editStoreComboList(data) {
  return http({
    url: "/admin/order/store/combo/edit",
    method: "post",
    data,
  });
}
